module.exports = __webpack_public_path__ + "img/app-google-play.2a90864.svg";